import { getConfigFromApi } from '@tcs/common/utils/getConfigFromApi';

export interface AppConfig {
  PUBLIC_ALLOW_DEBUG: string;
  PUBLIC_API_KEY: string;
  PUBLIC_API_SECRET: string;
  PUBLIC_SERVICE_HOST: string;
  PUBLIC_PARDOT_FORM_HANDLER: string;
  PUBLIC_CMS_URL: string;
  REACT_APP_BASE_PATH: string;
  PUBLIC_GTM_ID: string;
  PUBLIC_HOST: string;
  LOGROCKET_APP_ID: string;
  GOOGLE_ANALYTICS_TRACKING_ID: string;
  HEAP_APP_ID: string;
  LAUNCHDARKLY_CLIENT_ID: string;
  IMAGE_VERSION: string;
  ZENDESK_KEY: string;
  COOKIE_SECRET: string;
  SEGMENT_WRITE_KEY: string;
}

let config: AppConfig | null = null;

const loadConfig = async (): Promise<AppConfig> => {
  const configResult = await getConfigFromApi<AppConfig>();

  config = configResult;
  Object.freeze(config);

  return config;
};

export const getConfig = async (): Promise<AppConfig> => {
  if (config === null) {
    return await loadConfig();
  }
  return config;
};
